<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill-rule="evenodd" clip-rule="evenodd"><path d="M20.067 18.248h4.6v4.46a1.31 1.31 0 01-1.308 1.312h-3.292v-5.772zm6.6-2v6.46a3.31 3.31 0 01-3.308 3.312H19.72a1.655 1.655 0 01-1.654-1.656v-6.46c0-.915.74-1.656 1.654-1.656h6.945zm-14.735 2H7.333v4.46A1.31 1.31 0 008.64 24.02h3.292v-5.772zm-6.599-2v6.46A3.31 3.31 0 008.64 26.02h3.639c.913 0 1.653-.742 1.653-1.656v-6.46c0-.915-.74-1.656-1.653-1.656H5.333z"/><path d="M5.333 13.333C5.333 6.852 10.147 2.666 16 2.666c5.852 0 10.666 4.186 10.666 10.667v14.333c0 .92-.746 1.667-1.666 1.667h-9a1 1 0 110-2h8.666v-14c0-5.302-3.841-8.667-8.666-8.667s-8.667 3.365-8.667 8.667v9.333a1 1 0 11-2 0v-9.333z"/></g></svg>
</template>

<script>
export default {
  name: 'objectsHeadphoneOutline'
}
</script>
